module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/news-arrow-f5526160e86a84e13495ed623100fd99.svg&quot;;"